import PriceSchemeSelector from './PriceSchemeSelector';
export default PriceSchemeSelector;
